import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
}
export function AccordionItem({
  title,
  children,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-[#5C6B60]/10 last:border-0" data-id="element-167">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={onClick} data-id="element-168">
        <span className="text-lg font-medium text-[#2D3648] group-hover:text-[#5C6B60] transition-colors pr-4" data-id="element-169">
          {title}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-[#C2644C] flex-shrink-0" data-id="element-170" /> : <ChevronDown className="w-5 h-5 text-[#5C6B60] flex-shrink-0" data-id="element-171" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-172">
        <div className="text-[#4A5568] leading-relaxed" data-id="element-173">{children}</div>
      </div>
    </div>;
}
export function Accordion({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="w-full bg-white rounded-2xl shadow-sm border border-[#5C6B60]/10 px-6 md:px-8" data-id="element-174">
      {children}
    </div>;
}